import React, { useState, useEffect } from 'react';
import WaveApiService from '../../services/wave/waveApi';
import ProfitLossReport from './ProfitLossReport';
import ReportFilters from './ReportFilters';

const FinancialReports = () => {
  const [financialData, setFinancialData] = useState({
    invoices: [],
    expenses: [],
    loading: true,
    error: null
  });
  const [filters, setFilters] = useState({
    dateRange: 'month',
    startDate: null,
    endDate: null
  });

  const waveApi = new WaveApiService(process.env.REACT_APP_WAVE_API_KEY);

  useEffect(() => {
    fetchFinancialData();
  }, [filters]);

  const fetchFinancialData = async () => {
    try {
      const [invoicesRes, expensesRes] = await Promise.all([
        waveApi.getInvoices(),
        waveApi.getExpenses()
      ]);

      setFinancialData({
        invoices: invoicesRes.data.businesses.edges[0].node.invoices.edges,
        expenses: expensesRes.data.businesses.edges[0].node.expenses.edges,
        loading: false,
        error: null
      });
    } catch (error) {
      setFinancialData(prev => ({
        ...prev,
        loading: false,
        error: 'Failed to fetch financial data'
      }));
    }
  };

  return (
    <div className="financial-reports">
      <h2>Financial Reports</h2>
      <ReportFilters filters={filters} setFilters={setFilters} />
      {financialData.loading ? (
        <div>Loading...</div>
      ) : financialData.error ? (
        <div className="error">{financialData.error}</div>
      ) : (
        <ProfitLossReport 
          invoices={financialData.invoices}
          expenses={financialData.expenses}
          filters={filters}
        />
      )}
    </div>
  );
};

export default FinancialReports; 